import React, { useEffect, useState } from "react";
import { DialogContent, DialogContentText, Grid } from "@mui/material";
import Popup from "../../../../components/common/model/Popup";
import Notification from "../../../../components/common/notification/Notification";
import closeIcon from "../../../../assets/closeModel.png";
import checkedIcon from "../../../../assets/check-mark.png";
import deleteIcon from "../../../../assets/trash.png";
import useStyles from "../../../../components/common/model/styles";
import { BLINK_FIELDS } from "./bookAllFields";
import FormField from "../../../../components/common/FormField";
import {
  addBlink,
  initialBlinkState,
} from "../../../../store/reducers/quickBookSlice";
import ResetFormAlert from "../../../../components/common/ResetFormAlert";
import Validation from "../../../../utils/Validation";
import { useDispatch } from "react-redux";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";

interface ManageBlinkProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectData: any; // Adjust type as per your requirement
}

const ManageBlink: React.FC<ManageBlinkProps> = (props) => {
  const { selectData, onHide, open, title } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("sm"); // Adjust the type definition
  const [formData, setFormData] = useState<any>(initialBlinkState);
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [isClearActionCalled, setIsClearActionCalled] = useState(false);

  const hideHandler = () => {
    onHide();
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  const openClearPopup = () => {
    setIsClearActionCalled(true);
  };

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
  ]: any = Validation({
    apiKey: formData?.apiKey,
    secretKey: formData?.secretKey
  });

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  const onChangeAction = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = event.target;
    setFormData((prevState: any) => ({
      ...prevState,
      [id]: value,
    }));
  };

  useEffect(()=>{
    if(selectData?.apiKey){
      setFormData({
        apiKey: selectData?.apiKey,
        secretKey: selectData?.secretKey,
      });
      resetValidator();
    }
  },[selectData])

  const [isClickReset, setIsClickReset] = useState(false);

  const handleClear = () => {
    if(selectData?.apiKey){
      setFormData({
        apiKey: selectData?.apiKey,
        secretKey: selectData?.secretKey,
      });
    } else{
      setFormData(initialBlinkState);
    }
    resetAllValidator();
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  useEffect(() => {
    if (isClickReset) {
      handleClear();
      setIsClearActionCalled(false);
      setIsClickReset(false);
    }
  }, [isClickReset]);

  useEffect(() => {
    if (isActionCalled) {
      if (!isError() && error !== null && isActionCalled) {
        dispatch(addBlink(formData));
        setIsActionCalled(false);
      }
    }
    setIsActionCalled(false);
  }, [dispatch,isActionCalled]);

  const onBlurAction = (e: any) => {
    checkValidator(e.target.id);
  };

  return (
    <>
      <Popup
        open={open}
        title={title}
        onHide={hideHandler}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        aria-describedby="alert-dialog-slide-description"
        popupBg="#fff"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={classes.checkicons}
              alt="save"
            />
            <img
              onClick={openClearPopup}
              src={deleteIcon}
              className={classes.deleteicons}
              alt="delete"
            />
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
      >
        <DialogContent sx={{ padding: "10px" }}>
          <DialogContentText>
            <>
              <Notification />
              <Grid
                container
                spacing={0.5}
                sx={{
                  background: "#E5F4F1",
                  border: "1px solid #CFCFCF",
                  borderRadius: "5px",
                  padding: "10px",
                }}
              >
                {BLINK_FIELDS &&
                  BLINK_FIELDS.map((field) => (
                    <FormField
                      key={field.id}
                      // onPaste={(e) => e.preventDefault()}
                      onKeyDown={(event: any) => {
                        if (
                          event.keyCode === 8 ||
                          event.keyCode === 9 ||
                          event.keyCode === 37 ||
                          event.keyCode === 38 ||
                          event.keyCode === 39 ||
                          event.keyCode === 40 ||
                          event.keyCode === 18 ||
                          event.keyCode === 17 ||
                          event.ctrlKey
                        )
                          return event;
                        if (
                          field?.patternAllowed &&
                          !field?.patternAllowed.test(event.key)
                        ) {
                          event.preventDefault();
                        } else if (
                          field?.patternAllowed &&
                          !field?.patternAllowed.test(
                            event.target.value + event.key
                          )
                        ) {
                          event.preventDefault();
                        }
                      }}
                      {...{
                        ...field,
                        value: formData ? formData[field.id] || "" : "",
                        variant: "outlined",
                        minRows: 2,
                        isNonMarginTop: true,
                        inSingleGridForm: true,
                        onChange: onChangeAction,
                        onBlur: onBlurAction,
                        maxLength: 250,
                        InputProps: {
                          ...(field?.inputProps && field?.inputProps),
                          sx:
                            field?.type === "text" || field?.type === "password"
                              ? { height: "36px" }
                              : {
                                  padding: "10px 4px",
                                  height: "36px",
                                },
                        },
                        error: error && error[field?.id],
                      }}
                    />
                  ))}
                
              </Grid>
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {isClearActionCalled && (
        <ResetFormAlert
          open={isClearActionCalled}
          title=""
          alertModalShow={isClearActionCalled}
          setAlertModelShow={setIsClearActionCalled}
          setIsClickReset={setIsClickReset}
        />
      )}
    </>
  );
};

export default ManageBlink;
